import ModelViewer from './ModelViewer'
import { Settings } from './Settings'
import { version } from './Version'

export class ContextMenu extends HTMLElement {
	viewer: ModelViewer

	styles = String.raw`<style>
        menu{
            position: fixed;
            z-index: 1000;
            color: rgba(200, 200, 200, 1);
            margin: 0;
            padding: 0;
            list-style: none;
            background: rgba(0, 0, 0, .6);
            border-radius: 20px;
            padding: 10px;
            backdrop-filter: blur(8px);
        }
        h2{
            padding: 10px;
            margin: 0;
            font-family: FuturaLight, system-ui;
            font-weight: inherit;
            font-size: 16px;
            white-space: nowrap;
        }
        h2 span {
            font-family: LindbergLight, system-ui
        }
        label {
            font-family: FuturaLight, system-ui;
            font-size: 13px;
            display: block;
            padding: 10px;
            width: 100%;
            text-align: left;

        }
        button{
            font-family: FuturaLight, system-ui;
            font-size: 13px;
            display: block;
            padding: 10px;
            width: 100%;
            text-align: left;
            white-space: nowrap;
            appearance: none;
            outline: none;
            border: none;
            background: none;
            border-radius: 10px;
            color: rgba(200, 200, 200, 1);
        }
        button:hover {
            background: rgba(100, 100, 100, .75);
            color: white;
            cursor: pointer;
        }
    </style>`

	constructor(viewer: ModelViewer) {
		super()
		this.viewer = viewer
		this.viewer.canvas.addEventListener('contextmenu', this.show.bind(this))
		this.addEventListener('contextmenu', e => e.preventDefault())
		this.hide = this.hide.bind(this)

		this.attachShadow({ mode: 'open' })
	}

	show(e: MouseEvent) {
		if (!this.viewer.settings.contextMenu) return
		document.addEventListener('click', this.hide)
		this.viewer.shadowRoot.append(this)
		this.shadowRoot.innerHTML = this.styles + String.raw`<menu>
            <h2>${import.meta.env.VITE_APP_TITLE.replace(`LINDBERG`, String.raw`<span>LINDBERG</span>`)}</h2>
            <label>Version ${version}</label>
            <button value="fullscreen">Show Fullscreen</button>
            <button value="image">Save As Image</button>
            <button value="configuration">Copy Configuration Url</button>
            <button value="qr">Show QR Code</button>
            <!-- ${
			e.shiftKey ?
				String.raw`
                <button value="scale">Show Scale</button>
                <button value="debug">Show Debug Info</button>
            ` :
				''
		} -->
        </menu>`
		this.shadowRoot.querySelectorAll('button').forEach(btn =>
			btn.addEventListener('click', async e => {
				switch (btn.value) {
					case 'fullscreen':
						this.viewer.requestFullscreen({ 'navigationUI': 'hide' })
						break

					case 'image':
						const link = window.document.createElement('a')
						const Tools = await (await import('@babylonjs/core/Misc/tools')).Tools
						link.href = await Tools.CreateScreenshotUsingRenderTargetAsync(this.viewer.camera.getEngine(), this.viewer.camera, { width: 3200, height: 1600 }, 'image/png', 0, false)
						link.target = '_blank'
						link.download = this.viewer.configName + '.png'
						link.click()
						break
					case 'configuration':
						await navigator.clipboard.writeText(Settings.baseUrl + '?' + this.viewer.config)
						break
					case 'qr':
						await (await import('@shoelace-style/shoelace/dist/components/qr-code/qr-code.js')).default
						const css = document.createElement('style')
						css.innerText = `
                        sl-qr-code { position: fixed; z-index: 10000; top: 50%; left: 50%; transform: translate(-50%, -50%); padding: 10px; background: white; width: min(90vw, 320px); }
                        sl-qr-code::part(base){ width: 100%; height: 100%; }
                    `
						const qr = document.createElement('sl-qr-code')
						qr.errorCorrection = 'L'

						// qr.setAttribute("style", "")
						qr.value = Settings.baseUrl + '?' + this.viewer.config
						document.body.append(css)
						document.body.append(qr)
						requestAnimationFrame(() =>
							document.addEventListener('click', () => {
								css.remove()
								qr.remove()
							}, { once: true })
						) // Safari fix
						break
					case 'scale':
						// await import("./../RealWorldScale")
						// const scale = document.createElement("realtime-scale")
						// this.viewer.shadowRoot.append(scale)
						// break;
				}
				this.hide()
			})
		)
		this.shadowRoot!.querySelector('menu')!.setAttribute('style', `top: ${e.clientY}px; left: ${e.clientX}px`)
	}

	hide(e?: Event) {
		if (e && e.composedPath().includes(this)) return
		document.removeEventListener('click', this.hide)
		this.remove()
	}
}
customElements.define('realtime-contextmenu', ContextMenu)
